import React, { useMemo } from 'react';
import { MessageType } from '@wearejh/m2-pwa-engine/lib/types';

import { GoogleMapsApiProvider } from 'src/components/GoogleMaps/GoogleMapsApiProvider';
import { useDeps } from 'src/hooks/useDeps';

import { Messages } from '../Messages/Messages';

import classes from './PageBuilder.module.scss';
import parseStorageHtml from './utils/parseStorageHtml';
import ContentTypeFactory from './ContentTypeFactory';

type PageBuilderProps = {
    html: string;
};

export function PageBuilder(props: PageBuilderProps) {
    const { GOOGLE_MAPS_API_KEY } = useDeps().env;
    /**
     * Parse the HTML string and convert it to a ContentTypeObject
     * This will inline any style blocks within the string via the Juice package
     * convert the string into a DOM object and then walk the DOM object to create a ContentTypeObject
     *
     * This data is then passed into the content factory to render the content using the correct components
     */
    const data = useMemo(() => {
        return parseStorageHtml(props.html);
    }, [props.html]);

    if (!data || !data.children) {
        console.error('No children found in data');

        return (
            <Messages
                messages={[
                    {
                        text: 'No content available',
                        type: MessageType.Info,
                    },
                ]}
            />
        );
    }

    return (
        <GoogleMapsApiProvider apiKey={GOOGLE_MAPS_API_KEY} language="en">
            <div className={[classes['pbGlobal'], 'pageBuilderGlobal'].join(' ')}>
                {data?.children.map((child) => {
                    return <ContentTypeFactory data={child} key={child.uniqueID} />;
                })}
            </div>
        </GoogleMapsApiProvider>
    );
}
